export const updateInventoryItemMini = /* GraphQL */ `
  mutation UpdateInventoryItem(
    $input: UpdateInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    updateInventoryItem(input: $input, condition: $condition) {
      id
    }
  }
`;

export const createInventorieId = /* GraphQL */ `
  mutation CreateInventorie(
    $input: CreateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    createInventorie(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateInventorieInbound = /* GraphQL */ `
  mutation UpdateInventorie(
    $input: UpdateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    updateInventorie(input: $input, condition: $condition) {
      id
      groups
      reloadYardId
      status
      lotNumber
      poNumber
      inboundShipmentId
      railCarNumber
      inboundShipmentId
      receivedAt
      turnDays
      quantityAdvised
      quantityReceived
      quantityOnHand
      quantityPhysical
      quantityCommitted
      quantityMismatch
      inventoryUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      turnDays
      areaId
      area {
        areaType
      }
      zoneId
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      productName
      productId
      productCode
      accountId
      accountName
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        verified
        units
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
        }
      }
      inventoryItems {
        items {
          id
          quantityOnHand
          quantityCommitted
          hasException
          isDamaged
          otherException
          otherExceptionNote
          status
          unloadedBy
          unloadedAt
          inboundShipmentId
          inventoryId
          reloadYardId
          areaId
          zoneId
          aisleId
          locationId
          location {
            id
            owner
            groups
            active
            reloadYardId
            name
            type
            productId
            productName
            areaId
            area {
              id
              owner
              groups
              active
              reloadYardId
              name
              prefix
              color
              areaType
              sortKey
            }
            zoneId
            zone {
              id
              owner
              groups
              active
              reloadYardId
              name
              prefix
              accountId
              areaId
              color
              zoneType
              sortKey
            }
            aisleId
            aisle {
              id
              owner
              groups
              active
              reloadYardId
              name
              type
              areaId
              zoneId
              bays
              levels
              capacityUsed
              topDownPickOrder
              sortKey
            }
            bay
            level
            position
            capacityUsed
            capacityAllocated
            bulkCapacity
            bulkUnits
            sortKey
            locationLoad {
              other {
                selected
                capacity
              }
              pallet {
                selected
                capacity
              }
              box {
                selected
                capacity
              }
              container {
                selected
                capacity
              }
              superSack {
                selected
                capacity
              }
              dryBulk {
                selected
                capacity
              }
              liquidBulk {
                selected
                capacity
              }
            }
          }
          history {
            type
            date
            by
            text
          }
          outboundShipmentId
          locationFullName
          latitude
          longitude
        }
      }
      customFields
    }
  }
`;

export const updateInventorieMini = /* GraphQL */ `
  mutation UpdateInventorie(
    $input: UpdateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    updateInventorie(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateAuditInventorie = /* GraphQL */ `
  mutation UpdateInventorie(
    $input: UpdateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    updateInventorie(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      railCarNumber
      receivedAt
      depletedAt
      quantityAdvised
      quantityReceived
      quantityOnHand
      quantityPhysical
      quantityCommitted
      quantityMismatch
      inboundShipmentId
      inventoryUOM
      weight
      weightUOM
      verificationRequired
      lotType
      areaId
      zoneId
      # photos {
      #   bucket
      #   region
      #   key
      # }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      productId
      productCode
      productName
      product {
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
      }
      accountName
      accountId
      account {
        id
        businessName
      }
      auditId
      reloadYardCommodityId
      createdAt
      updatedAt
    }
  }
`;

export const updateInventorie = /* GraphQL */ `
  mutation UpdateInventorie(
    $input: UpdateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    updateInventorie(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      railCarNumber
      receivedAt
      depletedAt
      turnDays
      quantityAdvised
      quantityReceived
      quantityOnHand
      quantityPhysical
      quantityCommitted
      quantityMismatch
      inventoryUOM
      weight
      weightUOM
      verificationRequired
      inboundShipmentId
      reloadYardId
      lotType
      areaId
      zoneId
      photos {
        items {
          id
          bucket
          region
          key
          name
        }
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      productName
      productCode
      productId
      product {
        id
        owner
        groups
        active
        accountId
        reloadYardId
        name
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        width
        length
        height
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
        history {
          type
          date
          by
          text
        }
        createdAt
        updatedAt
      }
      sortKey
      accountName
      accountId
      account {
        id
        # owner
        groups
        active
        status
        externalId
        lotNumberPrefix
        businessName
        displayName
        defaultWeightUOM
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
        }
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
        }
        contacts {
          name
          email
          phone
          description
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        reloadYardId
        inboundCustomFields {
          id
          name
          type
          display
        }
        inboundInstructions
        podEmail
        outboundCustomFields {
          id
          name
          type
          display
        }
        outboundInstructions
        posEmail
        outboundSkipSignature
        inventoryCustomFields {
          id
          name
          type
          display
        }
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        bolTemplate {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        secondaryReview
        createdAt
        updatedAt
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        owner
        groups
        active
        status
        state
        poNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        carrierName
        lotType
        railCarNumber
        totalUOM
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        attachments {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        assignedTo
        workflowType
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        instructions
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
        }
        accountName
        accountId
        account {
          id
          # owner
          groups
          active
          status
          externalId
          lotNumberPrefix
          businessName
          displayName
          defaultWeightUOM
          email
          phone
          # fax
          # website
          billingEmail
          addressState
          reloadYardId
          inboundInstructions
          podEmail
          outboundInstructions
          posEmail
          outboundSkipSignature
          secondaryReview
          # createdAt
          # updatedAt
        }
        reloadYardId
        # inventories {
        #   nextToken
        # }
        invoiceId
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
          createdAt
          updatedAt
        }
        isCollected
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          sortKey
          createdAt
          updatedAt
        }
        customFields
        selectedCustomFields {
          id
          name
          type
          display
        }
        createdAt
        updatedAt
      }
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          sortKey
          lotNumber
          totalQuantityToPick
          outboundShipmentId
          accountId
          reloadYardId
          inventoryId
          createdAt
          updatedAt
        }
        nextToken
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        owner
        groups
        active
        verified
        units
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      customFields
      createdAt
      updatedAt
    }
  }
`;

export const updateInventorySearch = /* GraphQL */ `
  mutation UpdateInventorie(
    $input: UpdateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    updateInventorie(input: $input, condition: $condition) {
      id
      status
      lotNumber
      poNumber
      railCarNumber
      quantityAdvised
      quantityReceived
      quantityOnHand
      quantityCommitted
      quantityPhysical
      quantityMismatch
      inventoryUOM
      weight
      weightUOM
      hasException
      overShipment
      overShipmentQuantity
      underShipment
      underShipmentQuantity
      isDamaged
      isRecalled
      otherException
      aisleList
      account {
        inventoryPrimaryField
      }
      receivedAt
      depletedAt
      turnDays
      lotType
      inventoryItems {
        items {
          id
          quantityOnHand
          quantityCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          areaId
          zoneId
          aisleId
          locationId
          location {
            id
            name
            type
            area {
              name
              prefix
              areaType
            }
            zone {
              name
              prefix
              accountId
            }
            aisle {
              id
              active
              name
              type
              bays
              levels
              capacityUsed
              length
              width
              sortKey
            }
            bay
            level
            position
          }
          outboundShipmentId
          inboundShipmentId
          locationFullName
          latitude
          longitude
        }
      }
      areaId
      area {
        areaType
      }
      productName
      productCode
      productId
      product {
        category
        lowInventoryAlert
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
      }
      accountName
      accountId
      account {
        businessName
        displayName
      }
      inboundShipmentId
      inboundShipment {
        poNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        carrierName
        lotType
        railCarNumber
      }
      reloadYardId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        commodityId
        units
        commodity {
          id
          name
          locationLoadType
        }
      }
      customFields
      zoneId
    }
  }
`;

export const createInventoryItem = /* GraphQL */ `
  mutation CreateInventoryItem(
    $input: CreateInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    createInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      quantityOnHand
      quantityCommitted
      isDamaged
      hasException
      otherException
      otherExceptionNote
      status
      inboundShipmentId
      inventoryId
      inventory {
        id
        groups
        active
        status
        lotNumber
        poNumber
        railCarNumber
        receivedAt
        depletedAt
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        zoneId
        aisleList
        history {
          type
          date
          by
          text
        }
        productName
        productCode
        productId
        sortKey
        accountName
        accountId
        reloadYardId
        inboundShipmentId
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          groups
          active
          verified
          units
          sortKey
          commodity {
            id
            name
            description
          }
        }
        customFields
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        areaId
        color
        zoneType
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        productId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        length
        width
        sortKey
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedBy
      unloadedAt
      history {
        type
        date
        by
        text
      }
      createdAt
      updatedAt
    }
  }
`;

export const createInventoryItemId = /* GraphQL */ `
  mutation CreateInventoryItem(
    $input: CreateInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    createInventoryItem(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateInventoryItem = /* GraphQL */ `
  mutation UpdateInventoryItem(
    $input: UpdateInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    updateInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      quantityOnHand
      quantityCommitted
      hasException
      isDamaged
      otherException
      otherExceptionNote
      status
      inboundShipmentId
      inventoryId
      inventory {
        id
        groups
        active
        status
        lotNumber
        poNumber
        railCarNumber
        receivedAt
        depletedAt
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        areaId
        zoneId
        aisleList
        outboundShipmentId
        history {
          type
          date
          by
          text
        }
        productName
        productCode
        productId
        sortKey
        accountName
        accountId
        reloadYardId
        inboundShipmentId
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          groups
          active
          verified
          units
          sortKey
          commodity {
            id
            name
            description
          }
        }
        inventoryItems {
          items {
            aisleId
            status
          }
        }
        customFields
        createdAt
        updatedAt
      }
      areaId
      area {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        color
        areaType
        sortKey
        createdAt
        updatedAt
      }
      zoneId
      zone {
        id
        owner
        groups
        active
        reloadYardId
        name
        prefix
        accountId
        areaId
        color
        zoneType
        sortKey
        createdAt
        updatedAt
      }
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
          createdAt
          updatedAt
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        isContaminated
        length
        width
        sortKey
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        tags {
          nextToken
        }
        createdAt
        updatedAt
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      unloadedBy
      unloadedAt
      history {
        type
        date
        by
        text
      }
      createdAt
      updatedAt
    }
  }
`;

export const deleteInventorieMini = /* GraphQL */ `
  mutation DeleteInventorie(
    $input: DeleteInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    deleteInventorie(input: $input, condition: $condition) {
      id
    }
  }
`;

export const deleteInventoryItemMini = /* GraphQL */ `
  mutation DeleteInventoryItem(
    $input: DeleteInventoryItemInput!
    $condition: ModelInventoryItemConditionInput
  ) {
    deleteInventoryItem(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
    }
  }
`;
